import { FC, useEffect } from 'react';
import FileUploaderTile from '@views/AdminPage/ImportMedications/FileUploaderTile';
import FileUploader from '@views/AdminPage/ImportMedications/FileUploader/FileUploader';
import { EventType } from '@utils/eventBus';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import useDispatch from '@store/hooks/useDispatch';
import { handleAdminImportMedications } from '@store/features/adminImportMedications/actions';
import {
  adminImportMedicationsErrorsSelector,
  adminImportMedicationsLoadingSelector,
} from '@store/features/adminImportMedications/selectors';
import { removeAdminImportMedications } from '@store/features/adminImportMedications/slice';

const ImportMedicationsList: FC = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const isLoadingMedications = useSelector(adminImportMedicationsLoadingSelector);
  const errorsMedications = useSelector(adminImportMedicationsErrorsSelector);
  const hasErrorsMedications = errorsMedications.length > 0;

  useEffect(() => {
    dispatch(removeAdminImportMedications());
  }, []);

  return (
    <FileUploaderTile title={t('admin.importMedicationsHeader')}>
      <FileUploader
        className="import-medications__file-uploader"
        importHandler={handleAdminImportMedications}
        errors={errorsMedications}
        eventType={EventType.ADMIN_IMPORT_MEDICATIONS_SUCCESS}
        hasErrors={hasErrorsMedications}
        isLoading={isLoadingMedications}
        successMessage={t('admin.importMedicationsSuccess')}
      />
    </FileUploaderTile>
  );
};

export default ImportMedicationsList;
